import React,{useState, useEffect} from 'react'
import moment from 'moment';
import axiosInstance from '../../redux/axiosInstance'
import { CSVLink } from "react-csv";
import Pagination from "./Pagination";
// reactstrap components
import { 
    Card,
    CardHeader,
    DropdownMenu,
    DropdownItem,
    UncontrolledDropdown,   
    DropdownToggle,
    Table,
    Container,
    Row,
    Button
  } from "reactstrap";
  // core components
  import Header from "components/Headers/Header.js";
const License = () => {
    const [license, setLicense] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [dataPerPage] = useState(10)

  useEffect(() => { 
    axiosInstance.get("/license-verification/index")
      .then(res => {
        const license = res.data.data;
        setLicense(license);
      })
  }, []);

  //Change Page
  const paginate = pageNumber => setCurrentPage(pageNumber)

  const headers = [
    { label: "ID", key: "_id" },
    { label: "First Name", key: "first_name" },
    { label: "Last Name", key: "last_name" },
    { label: "Email", key: "email" },
    { label: "Phone", key: "phone" },
    { label: "City", key: "city" },
    { label: "State", key: "state" },
    { label: "Zip Code", key: "zipcode" },
    { label: "Agent Email", key: "agent_email" },
    { label: "Agent First Name", key: "agent_first_name" },
    { label: "Agent Last Name", key: "agent_last_name" },
    { label: "Agent City", key: "agent_city" },
    { label: "Agent Zip Code", key: "agent_zipcode" },
    { label: "Agent Phone", key: "agent_phone" },
    { label: "Agent State", key: "agent_state" },
    { label: "Agent License", key: "agent_license" },
    { label: "Message", key: "message" },
    { label: "Preferred Contact", key: "preferred_contact" },
    // { label: "Transaction", key: "transaction" },
    { label: "Created At", key: "created_at" },
    { label: "Updated At", key: "updated_at" },
  ];

  const csvReport = {
    data: license,
    headers: headers,
    filename: 'License_Verification_Report.csv'
  };

    return (
        <>
          <Header />
        {/* Page content */}
        <Container className="mt--7" fluid>
          {/* Table */}
          <Row>
            <div className="col">
              <Card className="shadow">
              <CardHeader className="border-0">
                  
                  <Button style={{float: 'right'}} color="info">
                    <CSVLink {...csvReport}>Export to CSV</CSVLink>
                  </Button>

                  

                </CardHeader>
                <CardHeader className="border-0">
                  <h3 className="mb-0">License Verification List</h3>
                  
                </CardHeader>
               
                <Table className="align-items-center table-flush" responsive>
                  <thead className="thead-light">
                    <tr>

                      <th scope="col">Name</th>
                      <th scope="col">Email</th>
                      <th scope="col">Phone</th>
                      <th scope="col">City</th>
                       <th scope="col">State</th>
                       <th scope="col">Zipcode</th>
                       <th scope="col">Agent's Name</th>
                      <th scope="col">Agent's Email</th>
                       <th scope="col">Agent's City</th>
                       <th scope="col">Agent's Zipcode</th>
                       <th scope="col">Agent's Phone</th>
                       <th scope="col">Agent's State</th>
                       <th scope="col">Agent's License</th>
                       <th scope="col">Message</th>
                       <th scope="col">Contact By</th>
                       <th scope="col">Received On</th>
                      <th scope="col" />
                    </tr>
                  </thead>
                  <tbody>

                      {
                        license.map((lic, index)=>(
                        <tr key={index}>                      
                          <td>{lic.first_name} {lic.last_name}</td>
                          <td>{lic.email}</td>
                          <td>{lic.phone}</td>
                          <td>{lic.city}</td>
                          <td>{lic.state}</td>
                          <td>{lic.zipcode}</td>
                          <td>{lic.agent_email}</td>
                          <td>{lic.agent_first_name} {lic.agent_first_name}</td>
                          <td>{lic.agent_city}</td>
                          <td>{lic.agent_zipcode}</td>
                          <td>{lic.agent_phone}</td>
                          <td>{lic.agent_state}</td>
                          <td>{lic.agent_license}</td>
                          <td>{lic.message}</td>
                          <td>{lic.preferred_contact}</td>
                          <td>{moment(lic.created_at).fromNow()}</td>
                         
                         
                          <td className="text-right">
                        <UncontrolledDropdown>
                          <DropdownToggle
                            className="btn-icon-only text-light"
                            href="#!"
                            role="button"
                            size="sm"
                            color=""
                            onClick={e => e.preventDefault()}
                          >
                            <i className="fas fa-ellipsis-v" />
                          </DropdownToggle>
                          <DropdownMenu className="dropdown-menu-arrow" right>
                            <DropdownItem
                              href="#!"
                              onClick={e => e.preventDefault()}
                            >
                              View
                            </DropdownItem>
                        
                           
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </td>
                      </tr>
                        ))
                      }
                    
                  </tbody>
                </Table>
                <Pagination dataPerPage={dataPerPage} totalData={license.length} paginate={paginate} />
              </Card>
            </div>
          </Row>
         
        </Container>  
        </>
    )
}

export default License;
